import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { apiClient } from '@cast/infrastructure-api';
import { WorkloadScalingPolicy } from '@cast/types';

import { getWorkloadQueryKey } from 'hooks/queries/workload-optimization/useWorkloadQuery';
import { getWorkloadScalingPoliciesQueryKey } from 'hooks/queries/workload-optimization/useWorkloadScalingPoliciesQuery';
import { getWorkloadsQueryKey } from 'hooks/queries/workload-optimization/useWorkloadsQuery';

type CreatePolicyInput = Parameters<
  typeof apiClient.workloadOptimization.createWorkloadScalingPolicy
>[0];

type UseBatchCreateScalingPoliciesMutationProps = {
  onSuccess?: (
    results: PromiseSettledResult<AxiosResponse<WorkloadScalingPolicy>>[]
  ) => void;
};

export const useBatchCreateScalingPoliciesMutation = ({
  onSuccess,
}: UseBatchCreateScalingPoliciesMutationProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (inputs: CreatePolicyInput[]) =>
      Promise.allSettled(
        inputs.map((input) =>
          apiClient.workloadOptimization.createWorkloadScalingPolicy(input)
        )
      ),
    onSuccess: (results) => {
      queryClient.invalidateQueries({
        queryKey: getWorkloadScalingPoliciesQueryKey(),
      });
      queryClient.invalidateQueries({ queryKey: getWorkloadQueryKey() });
      queryClient.invalidateQueries({ queryKey: getWorkloadsQueryKey() });
      onSuccess?.(results);
    },
  });
};
